import { ComponentProps, FC } from 'react';
import { SidebarBase } from './SidebarBase';
import { BaseSidebarItem } from './SidebarBase/SidebarNavigation/Items/BaseSidebarItem';

type SidebarUtilityNavProps = {
  classNames?: ComponentProps<typeof BaseSidebarItem>['classNames'] & {
    item?: string;
  };
};

export const SidebarUtilityNav: FC<SidebarUtilityNavProps> = ({ classNames }) => (
  <div className='flex shrink-0 flex-col gap-1'>
    <SidebarBase.SettingsItem classNames={classNames} />
    <SidebarBase.SupportItem classNames={classNames} />
  </div>
);
